// Listagem das Configurações de pagamento (vencimento, multa, juros) — tela da
// Administração. A loja vem do seletor global do menu.
import { PlusIcon } from "lucide-react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { Button } from "@/components/ui/button"
import { FRONTEND_ROUTES } from "@/constants"
import {
  PaymentConfigurationsPanel,
  useCanWritePaymentConfigurations,
} from "@/features/payment-configurations"

const prefix = "pages.paymentConfigurations"

export function PaymentConfigurationsPage() {
  const { t } = useTranslation()
  const canWrite = useCanWritePaymentConfigurations()

  return (
    <DashboardContainer>
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            { label: t("sidebar.administration") },
            { label: t("sidebar.paymentConfigurations") },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div className="flex flex-col gap-1">
            <h1 className="page-title">
              {t(`${prefix}.title`)}
            </h1>
            <p className="text-sm text-muted-foreground">
              {t(`${prefix}.subtitle`)}
            </p>
          </div>
          {canWrite && (
            <Button asChild className="shrink-0 gap-2">
              <Link
                to={
                  FRONTEND_ROUTES
                    .PAYMENT_CONFIGURATIONS_CREATE.href
                }
              >
                <PlusIcon
                  className="h-4 w-4"
                  aria-hidden="true"
                />
                {t(`${prefix}.actions.create`)}
              </Link>
            </Button>
          )}
        </div>
        <PaymentConfigurationsPanel />
      </section>
    </DashboardContainer>
  )
}
